"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconNamesLogo = exports.IconNames60 = exports.IconNames40 = exports.IconNames24 = exports.IconNames16 = exports.IconNames8 = void 0;
var IconNames8;
exports.IconNames8 = IconNames8;

(function (IconNames8) {
  IconNames8["ARROW_RIGHT"] = "arrow-right";
  IconNames8["BULLET_LARGE"] = "bullet-large";
  IconNames8["BULLET_SMALL"] = "bullet-small";
  IconNames8["CARET_DOWN"] = "caret-down";
  IconNames8["CARET_LEFT"] = "caret-left";
  IconNames8["CARET_RIGHT"] = "caret-right";
  IconNames8["CARET_UP"] = "caret-up";
  IconNames8["CROSS"] = "cross";
  IconNames8["LINE"] = "line";
  IconNames8["TICK"] = "tick";
})(IconNames8 || (exports.IconNames8 = IconNames8 = {}));

var IconNames16;
exports.IconNames16 = IconNames16;

(function (IconNames16) {
  IconNames16["ADD"] = "add";
  IconNames16["ADP"] = "adp";
  IconNames16["ADVERT"] = "advert";
  IconNames16["APPLIED"] = "applied";
  IconNames16["ARCHIVE"] = "archive";
  IconNames16["ARROW_DOWN"] = "arrow-down";
  IconNames16["ARROW_LEFT"] = "arrow-left";
  IconNames16["ARROW_RIGHT"] = "arrow-right";
  IconNames16["ARROW_UP"] = "arrow-up";
  IconNames16["ATTACHMENT"] = "attachment";
  IconNames16["BAMBOOHR"] = "bamboohr";
  IconNames16["BASKET"] = "basket";
  IconNames16["BOB"] = "bob";
  IconNames16["BOLD"] = "bold";
  IconNames16["BREATHE"] = "breathe";
  IconNames16["BRYQ"] = "bryq";
  IconNames16["CALENDAR"] = "calendar";
  IconNames16["CANDIDATES"] = "candidates";
  IconNames16["CAPPFINITY"] = "cappfinity";
  IconNames16["CARDS"] = "cards";
  IconNames16["CARE_PLANNER"] = "care-planner";
  IconNames16["CARET_DOWN"] = "caret-down";
  IconNames16["CARET_LEFT"] = "caret-left";
  IconNames16["CARET_RIGHT"] = "caret-right";
  IconNames16["CARET_UP"] = "caret-up";
  IconNames16["CAROUSEL"] = "carousel";
  IconNames16["CASCADE_BY_IRIS"] = "cascade-by-iris";
  IconNames16["CERTN"] = "certn";
  IconNames16["CHART_PIE"] = "chart-pie";
  IconNames16["CHAT"] = "chat";
  IconNames16["CHECKED"] = "checked";
  IconNames16["CHECKR"] = "checkr";
  IconNames16["CHEVRON_DOWN"] = "chevron-down";
  IconNames16["CHEVRON_LEFT"] = "chevron-left";
  IconNames16["CHEVRON_RIGHT"] = "chevron-right";
  IconNames16["CHEVRON_UP"] = "chevron-up";
  IconNames16["CINTRA"] = "cintra";
  IconNames16["CLOCK"] = "clock";
  IconNames16["CLOSE"] = "close";
  IconNames16["CODE"] = "code";
  IconNames16["CODILITY"] = "codility";
  IconNames16["COMMENTS"] = "comments";
  IconNames16["COMPANY"] = "company";
  IconNames16["COMPARE"] = "compare";
  IconNames16["CRITERIA"] = "criteria";
  IconNames16["CURSOR"] = "cursor";
  IconNames16["DELETE"] = "delete";
  IconNames16["DEPARTMENT"] = "department";
  IconNames16["DOCUMENT"] = "document";
  IconNames16["DOCUSIGN"] = "docusign";
  IconNames16["DOWNLOAD"] = "download";
  IconNames16["DRAFT"] = "draft";
  IconNames16["DUPLICATE"] = "duplicate";
  IconNames16["EDIT"] = "edit";
  IconNames16["EMAIL"] = "email";
  IconNames16["EMAIL_OPEN"] = "email-open";
  IconNames16["ERROR"] = "error";
  IconNames16["EYE"] = "eye";
  IconNames16["EYE_OFF"] = "eye-off";
  IconNames16["FILTER"] = "filter";
  IconNames16["GLASSDOOR"] = "glassdoor";
  IconNames16["GOOGLE"] = "google";
  IconNames16["HEADING1"] = "heading1";
  IconNames16["HEADING2"] = "heading2";
  IconNames16["HEADING3"] = "heading3";
  IconNames16["HEART"] = "heart";
  IconNames16["HELP"] = "help";
  IconNames16["HERO"] = "hero";
  IconNames16["HIRED"] = "hired";
  IconNames16["IMAGE"] = "image";
  IconNames16["INDEED"] = "indeed";
  IconNames16["INDENT_LEFT"] = "indent-left";
  IconNames16["INDENT_RIGHT"] = "indent-right";
  IconNames16["INFO"] = "info";
  IconNames16["INTELLIHR"] = "intellihr";
  IconNames16["INTERVIEW"] = "interview";
  IconNames16["INTERVIEW2"] = "interview2";
  IconNames16["IRISH_JOBS_BOARD"] = "irish-jobs-board";
  IconNames16["ITALIC"] = "italic";
  IconNames16["JOB"] = "job";
  IconNames16["JOTFORM"] = "jotform";
  IconNames16["LINK"] = "link";
  IconNames16["LINKEDIN"] = "linkedin";
  IconNames16["LIST_BULLETED"] = "list-bulleted";
  IconNames16["LIST_NUMBERED"] = "list-numbered";
  IconNames16["LOCATION"] = "location";
  IconNames16["LOCK"] = "lock";
  IconNames16["LOGOUT"] = "logout";
  IconNames16["MENU"] = "menu";
  IconNames16["MINUS"] = "minus";
  IconNames16["MY_INTERVIEW"] = "my-interview";
  IconNames16["NAVIGATION"] = "navigation";
  IconNames16["NOTIFICATIONS"] = "notifications";
  IconNames16["ORACLE"] = "oracle";
  IconNames16["OVERFLOW"] = "overflow";
  IconNames16["PEOPLEHR"] = "peoplehr";
  IconNames16["PINPOINt"] = "pinpoint";
  IconNames16["PRINT"] = "print";
  IconNames16["QUOTE"] = "quote";
  IconNames16["RATING_1"] = "rating-1";
  IconNames16["RATING_2"] = "rating-2";
  IconNames16["RATING_3"] = "rating-3";
  IconNames16["RATING_4"] = "rating-4";
  IconNames16["RATING_5"] = "rating-5";
  IconNames16["REARRANGE"] = "rearrange";
  IconNames16["REDO"] = "redo";
  IconNames16["REFNOW"] = "refnow";
  IconNames16["REJECTED"] = "rejected";
  IconNames16["REVIEW"] = "review";
  IconNames16["ROTATE_CCW"] = "rotate-ccw";
  IconNames16["ROTATE_CW"] = "rotate-cw";
  IconNames16["SAGE_PEOPLE"] = "sage-people";
  IconNames16["SAML"] = "saml";
  IconNames16["SAPLING"] = "sapling";
  IconNames16["SAVE"] = "save";
  IconNames16["SCORECARD"] = "scorecard";
  IconNames16["SEARCH"] = "search";
  IconNames16["SENDING"] = "sending";
  IconNames16["SETTINGS"] = "settings";
  IconNames16["SLACK"] = "slack";
  IconNames16["SONRU"] = "sonru";
  IconNames16["SORT_ASC"] = "sort-asc";
  IconNames16["SORT_DESC"] = "sort-desc";
  IconNames16["SPLIT_VIEW"] = "split-view";
  IconNames16["STACKED_VIEW"] = "stacked-view";
  IconNames16["STAR"] = "star";
  IconNames16["STAR_FILLED"] = "star-filled";
  IconNames16["STERLING"] = "sterling";
  IconNames16["SUCCESS"] = "success";
  IconNames16["TALENT_DOT_COM"] = "talent-dot-com";
  IconNames16["TEXT"] = "text";
  IconNames16["TICK"] = "tick";
  IconNames16["TOTAL_JOBS"] = "total-jobs";
  IconNames16["UNCHECKED"] = "unchecked";
  IconNames16["UNDERLINE"] = "underline";
  IconNames16["UNDO"] = "undo";
  IconNames16["UPDATES"] = "updates";
  IconNames16["UPLOAD"] = "upload";
  IconNames16["USER"] = "user";
  IconNames16["VIDEO"] = "video";
  IconNames16["WEIGHT"] = "weight";
  IconNames16["WINDOWS"] = "windows";
  IconNames16["WORKFLOW"] = "workflow";
  IconNames16["ZAPIER"] = "zapier";
  IconNames16["ZIP_RECRUITER"] = "zip-recruiter";
})(IconNames16 || (exports.IconNames16 = IconNames16 = {}));

var IconNames24;
exports.IconNames24 = IconNames24;

(function (IconNames24) {
  IconNames24["ADVERTS"] = "adverts";
  IconNames24["CANDIDATES"] = "candidates";
  IconNames24["COMPANY"] = "company";
  IconNames24["DASHBOARD"] = "dashboard";
  IconNames24["INSIGHTS"] = "insights";
  IconNames24["JOBS"] = "jobs";
  IconNames24["ONBOARDING"] = "onboarding";
  IconNames24["RECRUITMENT"] = "recruitment";
  IconNames24["SETTINGS"] = "settings";
  IconNames24["SURVEYS_REVERSED"] = "surveys-reversed";
  IconNames24["USER"] = "user";
})(IconNames24 || (exports.IconNames24 = IconNames24 = {}));

var IconNames40;
exports.IconNames40 = IconNames40;

(function (IconNames40) {
  IconNames40["JPG"] = "jpg";
  IconNames40["PNG"] = "png";
  IconNames40["SVG"] = "svg";
})(IconNames40 || (exports.IconNames40 = IconNames40 = {}));

var IconNames60;
exports.IconNames60 = IconNames60;

(function (IconNames60) {
  IconNames60["CIRCLE"] = "circle";
  IconNames60["CRESCENTS"] = "crescents";
  IconNames60["CROSS"] = "cross";
  IconNames60["DIAMOND"] = "diamond";
  IconNames60["FLOWER"] = "flower";
  IconNames60["RAINBOW"] = "rainbow";
  IconNames60["TARGET"] = "target";
  IconNames60["WINDOW"] = "window";
})(IconNames60 || (exports.IconNames60 = IconNames60 = {}));

var IconNamesLogo;
exports.IconNamesLogo = IconNamesLogo;

(function (IconNamesLogo) {
  IconNamesLogo["FACEBOOK"] = "facebook";
  IconNamesLogo["GOOGLE"] = "google";
  IconNamesLogo["LINKEDIN"] = "linkedin";
  IconNamesLogo["MICROSOFT"] = "microsoft";
  IconNamesLogo["TWITTER"] = "twitter";
  IconNamesLogo["WHATSAPP"] = "whatsapp";
})(IconNamesLogo || (exports.IconNamesLogo = IconNamesLogo = {}));